import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { USERS_QUERIES } from "~/shared/api/users/users.queries";
import { notFound } from "~/shared/util/notFound";

export async function surveyDetailViewLoader({ params }: LoaderFunctionArgs, queryClient: QueryClient) {
  const { surveyId } = params;
  const user = await queryClient.ensureQueryData(USERS_QUERIES.profile());

  if (!surveyId) {
    return notFound();
  }

  queryClient.prefetchQuery(USERS_QUERIES.survey(user.id.toString(), surveyId));

  return null;
}
